<template lang='pug'>
  el-card.ec-campagin-card(
    v-if='item.campaign_name'
    @click.native="openProject"
  )
    .card-title
      span {{ item.campaign_name }}
      //- img(
      //-   v-if="item.is_bypass"
      //-   src="@/umcc/assets/bypass.png"
      //- )
    hr.divider
    .title-row(style="margin-left:0 !important") {{ $t('品牌') }}
    .content-row(v-if="item.brand.length !== 0" style="margin-left:0 !important") {{ item.brand[0].brand_name }}
    .title-row(style="margin-left:0 !important") {{ $t('渠道') }}
    .content-row(style="margin-left:0 !important") {{ item.channel_name }}
</template>

<script>
export default {
  components: {},
  props: {
    item: {
      type: Object,
      default () {
        return {
          brand: []
        }
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {
    openProject () {
      this.$store.commit('campaign/setId', this.item.campaign_id)
      this.$router.push('/ec-campaign/overview')
    }
  }
}
</script>

<style lang='stylus'>
.ec-campagin-card
  position relative
  .card-title
    font-size 16px
    display flex
    img
      position absolute
      height 20px
      right 0
      top 25px
    span
      width: 100%;
      text-overflow: ellipsis;
      word-break: keep-all;
      overflow: hidden;  
  .title-row
    color #bababa
    line-height 12px
    font-size 12px
  .content-row
    margin-bottom 12px
  .divider
    margin 12px 0 16px
    border 0.5px solid rgb(216, 216, 216)
</style>
